export const categories = [
  {
    id: "romance",
    name: "恋爱",
    icon: "ri-heart-3-line",
    desc: "心动瞬间与甜蜜羁绊，收集让人脸红的恋爱漫画。",
  },
  {
    id: "fantasy",
    name: "奇幻",
    icon: "ri-magic-line",
    desc: "魔法、异世界与神秘冒险，展开你的幻想之旅。",
  },
  {
    id: "action",
    name: "热血",
    icon: "ri-fire-line",
    desc: "燃到炸裂的对决与成长，少年漫的最强热血。",
  },
  {
    id: "girl",
    name: "少女",
    icon: "ri-flower-line",
    desc: "唯美画风与细腻情感，献给所有少女心读者。",
  },
  {
    id: "campus",
    name: "校园",
    icon: "ri-book-2-line",
    desc: "青春校园日常，教室、社团与操场上的故事。",
  },
  {
    id: "suspense",
    name: "悬疑",
    icon: "ri-spy-line",
    desc: "烧脑推理与惊悚谜题，层层反转停不下来。",
  },
  {
    id: "daily",
    name: "日常",
    icon: "ri-cup-line",
    desc: "治愈系生活小品，温柔又让人放松的日常。",
  },
  {
    id: "comedy",
    name: "搞笑",
    icon: "ri-emotion-laugh-line",
    desc: "沙雕爆笑名场面，专治不开心的快乐源泉。",
  },
];